import { useParams, useNavigate, useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import { PublicMenuStartPage } from "./PublicMenuStartPage"
import { useReloadMemory } from "../../hooks/useReloadMemory"
import { PATH_MAP } from "../../configuration/PathMap"
import { companyMemory } from "../../Objects/Memory/Memory"
import { initializePublicMenuTracking, trackPublicMenuPageView } from "../../analytics/publicMenuTracking"

const PublicPage = () => {
  const { restaurantSlug } = useParams<{ restaurantSlug: string }>()

  const navigate = useNavigate()

  const { pathname, search } = useLocation()

  const [loading, setLoading] = useState(false)

  const [isCatalogLoading, setIsCatalogLoading] = useState(true)

  const { handleReloadPublicMemory } = useReloadMemory()

  useEffect(() => {
    if (!restaurantSlug) return

    let active = true

    const load = async () => {
      setLoading(false)
      setIsCatalogLoading(true)

      const hasRestaurant = await handleReloadPublicMemory(restaurantSlug, () => {
        if (active) {
          setIsCatalogLoading(false)
        }
      })

      if (!active) {
        return
      }

      if (!hasRestaurant) {
        navigate(PATH_MAP.RESTAURANT_SEARCH_PAGE, { replace: true })
        return
      }

      initializePublicMenuTracking(companyMemory)

      setLoading(true)
    }

    load()

    return () => {
      active = false
    }
  }, [restaurantSlug, navigate])

  useEffect(() => {
    if (!loading) {
      return
    }

    trackPublicMenuPageView(companyMemory, `${pathname}${search}`, document.title)
  }, [loading, pathname, search])

  if (!loading) {
    return <></>
  }

  return <PublicMenuStartPage isCatalogLoading={isCatalogLoading} />
}

export default PublicPage
